<div class="dashboard__content-col">
  <div class="header">
    <div class="header__page-name">
      <h1 class="heading heading--main">{{title}}</h1>
    </div>
    
  </div>
 
</div>